import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { GenerativeAIServiceTick } from "../../../app-constants";

function Superchargelogistics() {
  return (
    <section
      className="supercharge_logistics p-100"
      style={{ background: "#FAFAFA" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Supercharge Your <span>Logistics with Advanced</span> App Features
            </h2>
            <p>
              As a top logistics application development company, we integrate
              advanced features to optimize your operations, enhance real-time
              visibility, and drive business growth.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                },
                1600: {
                  slidesPerView: 3,
                },
              }}
              className="logistics-slider"
            >
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Driver Management</h5>
                    <p>
                      Streamline driver assignment and performance tracking.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Real-Time GPS Tracking</h5>
                    <p>
                      Monitor fleet location and delivery status in real-time.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Route Optimization</h5>
                    <p>
                      Reduce fuel costs with automated, efficient route
                      planning.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Automated Dispatching</h5>
                    <p>
                      Assign tasks and routes automatically based on
                      availability.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Order & Delivery Management</h5>
                    <p>
                      Track order progress from placement to successful
                      delivery.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Geofencing</h5>
                    <p>
                      Set location-based triggers for operational alerts and
                      notifications.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Inventory Management</h5>
                    <p>
                      Monitor stock levels and automate inventory replenishment.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Payment Integration</h5>
                    <p>
                      Enable seamless in-app payments for drivers and customers.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Custom Reports</h5>
                    <p>
                      Generate detailed reports on fleet performance and
                      efficiency.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Push Notifications</h5>
                    <p>
                      Instant updates on delivery status, task assignments, and
                      alerts
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Multi-Language Support</h5>
                    <p>Serve global users with multiple language options.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Customer Feedback System</h5>
                    <p>
                      Collect real-time feedback for continuous service
                      improvement.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Superchargelogistics;
